import { n as Ie, o as re } from "./layout-BD1t4ofR.js";
import { n as A } from "./common-Cd7R8f1s.js";
import { n as _ } from "./Logger-CmiOOsKC.js";
import { a as we, b as ne, p as Se, t as J } from "./tracebehavior-5_qSKjs6.js";
import { R as Ae } from "./SceneCreation-DVCYLXYF.js";
import { n as Ce, r as j } from "./bindingValues-BuN2Qy2j.js";
import { Z as Y } from "./ScriptRegistry-C3vqndus.js";
import { r as oe } from "./properties-C_pgb9zu.js";
import { _ as Ne, b as Te, g as Re } from "./AssetTypes-DUDo9FdH.js";
import { t as De } from "./Utility-CviQuQTA.js";
import { t as Fe } from "./ModelLoader-CCmBcIkj.js";
import { f as Le } from "./theme-vocabulary-CiKlp9h0.js";
import { Matrix as ae, Vector3 as f } from "@babylonjs/core/Maths/math.vector.js";
import { Observable as le } from "@babylonjs/core/Misc/observable.js";
import { Mesh as _e } from "@babylonjs/core/Meshes/mesh.js";
import { MeshBuilder as Ee } from "@babylonjs/core/Meshes/meshBuilder.js";
import { StandardMaterial as k } from "@babylonjs/core/Materials/standardMaterial.js";
import "@babylonjs/core/Meshes/Builders/planeBuilder.js";
import { PointerEventTypes as R } from "@babylonjs/core/Events/pointerEvents.js";
import { Color3 as ee, Color4 as $e } from "@babylonjs/core/Maths/math.color.js";
import { Material as ke } from "@babylonjs/core/Materials/material.js";
import { TransformNode as Be } from "@babylonjs/core/Meshes/transformNode.js";
import { PBRMaterial as ce } from "@babylonjs/core/Materials/PBR/pbrMaterial.js";
import { RawTexture as ze } from "@babylonjs/core/Materials/Textures/rawTexture.js";
import { Texture as L } from "@babylonjs/core/Materials/Textures/texture.js";
import { Plane as H } from "@babylonjs/core/Maths/math.plane.js";
import { UtilityLayerRenderer as Ge } from "@babylonjs/core/Rendering/utilityLayerRenderer.js";
import { CreateDisc as je } from "@babylonjs/core/Meshes/Builders/discBuilder.js";
import { CreateLines as he } from "@babylonjs/core/Meshes/Builders/linesBuilder.js";
import { CreateTorus as He } from "@babylonjs/core/Meshes/Builders/torusBuilder.js";
import { VertexBuffer as W } from "@babylonjs/core/Buffers/buffer.js";
var We = "https://storageacceausprod.blob.core.windows.net/trace-cms-models/NjM4NjgxNTg1NDc3MDIxODk3LTVmZjE3ODkzLTRjMGEtNGI1MS05ODZhLTNhNjljNzY5NzNkZQ==.glb", Ue = 2, Xe = 0.05, kt = class extends J {
  static behaviorType = "Frame";
  frameParts;
  isLoaded;
  childMesh = null;
  _containerPath;
  _loadedSrc;
  _clonedMaterial = null;
  _authoredAlbedo = null;
  _fitObserver = null;
  _orientationObserver = null;
  constructor(t, e) {
    super(t, e), this.validate(this.getAuthored()), this._resolved = this._resolveAll(), this.frameParts = {}, this.isLoaded = !1, this._loadedSrc = this._resolved.src, _.debug(`[Frame] Creating new Frame behavior for object: ${t.name}, borderWidth: ${this._resolved.borderWidth}, color: ${this._resolved.color || "none"}`);
  }
  validate(t) {
    return t.borderColor && !t.color && (t.color = t.borderColor, delete t.borderColor), delete t.scaleFactor, delete t.importedWidth, [];
  }
  async applyCommit(t) {
    if (this._resolved.src !== this._loadedSrc) {
      await this.load(), this.attachedNode && this.onAttach(this.attachedNode), this._loadedSrc = this._resolved.src;
      return;
    }
    this.applyImmediateProperties();
  }
  applyImmediateProperties() {
    this._applyColor(j(this._resolved.color, "Frame.color"));
    const t = this.sceneObject.getBehavior(Y);
    t && this.adjustFrame(t);
  }
  _applyColor(t) {
    if (t === null) {
      this._clonedMaterial && this._authoredAlbedo && this._writeAlbedo(this._authoredAlbedo);
      return;
    }
    const e = ee.FromHexString(t);
    if (this._clonedMaterial)
      this._writeAlbedo(e);
    else {
      let s = null;
      for (const r in this.frameParts) {
        const n = this.frameParts[r];
        if (n && n.getChildren().length > 0) {
          const o = n.getChildren()[0];
          if (o.material instanceof ce) {
            s = o.material;
            break;
          }
        }
      }
      if (!s) return;
      const i = Ae(s, `${s.name}_${this.sceneObject.name}`);
      if (!i) return;
      this._authoredAlbedo = i.albedoColor?.clone() ?? null, i.albedoColor = e;
      for (const r in this.frameParts) {
        const n = this.frameParts[r];
        if (n && n.getChildren().length > 0) {
          const o = n.getChildren()[0];
          o.material = i;
        }
      }
      this._clonedMaterial = i;
    }
    _.debug(`[Frame] Applied color ${t} to frame materials`);
  }
  _writeAlbedo(t) {
    for (const e in this.frameParts) {
      const s = this.frameParts[e];
      if (s && s.getChildren().length > 0) {
        const i = s.getChildren()[0];
        if (i.material instanceof ce) {
          i.material.albedoColor = t.clone();
          break;
        }
      }
    }
  }
  async load() {
    this.isLoaded && this._disposeFrame(), _.debug(`[Frame] Loading frame model for ${this.sceneObject.name}`), this.isLoaded = !0;
    const t = Ce(this._resolved.src) ? this._resolved.src : We;
    try {
      const e = await Fe(t, this.scene, this.resources, {
        parent: this.sceneObject.transform,
        resetTransform: !0,
        pluginExtension: ".glb",
        cloneMeshes: !0
      });
      this.childMesh = e.root, this._containerPath = e.containerPath, _.debug(`[Frame] Loaded frame model for ${this.sceneObject.name}`);
    } catch (e) {
      _.warn(`[Frame] Failed to load frame model: ${String(e)}`);
    }
  }
  init() {
    if (_.debug(`[Frame] init() called for ${this.sceneObject.name} - childMesh exists: ${!!this.childMesh}, frameParts count: ${Object.keys(this.frameParts).length}, color: ${this._resolved.color}`), !this.childMesh) {
      _.error(`[Frame] Missing frame mesh for ${this.sceneObject.name}`);
      return;
    }
    const t = Object.keys(this.frameParts).length > 0;
    if (_.debug(`[Frame] hasFrameParts: ${t}`), !t) {
      const e = this.childMesh, s = e.getChildren(void 0, !1);
      _.debug(`[Frame] Found ${s.length} children in frame model`);
      const i = [
        "Top",
        "Bottom",
        "Back",
        "Right",
        "Left",
        "Bottom Right",
        "Bottom Left",
        "Top Right",
        "Top Left"
      ], r = new RegExp(`^${e.name}_`);
      i.forEach((n) => {
        const o = s.find((a) => a.name.replace(r, "") === n);
        this.frameParts[n] = o, o ? _.debug(`[Frame] Found frame part: ${n}, has children: ${o.getChildren().length > 0}`) : _.warn(`[Frame] Frame part not found: ${n}`);
      }), _.debug(`[Frame] Total frame parts found: ${Object.keys(this.frameParts).filter((n) => this.frameParts[n]).length}/9`);
    }
    this._applyColor(j(this._resolved.color, "Frame.color"));
  }
  onAttach(t) {
    if (_.debug(`[Frame] onAttach() called for ${this.sceneObject.name} - childMesh exists: ${!!this.childMesh}, frameParts count: ${Object.keys(this.frameParts).length}, color: ${this._resolved.color}`), !this.childMesh) {
      _.debug(`[Frame] No childMesh, returning from onAttach for ${this.sceneObject.name}`);
      return;
    }
    const e = this.sceneObject.getBehavior(Y);
    let s = t;
    if (e) {
      const i = this.sceneObject.getChildTransforms().find((r) => r.name === `${this.sceneObject.name}_mesh`);
      if (i) {
        const r = i.parent;
        r instanceof Be && (s = r), _.debug(`[Frame] Found graphic mesh: ${i.name}, attaching frame as sibling under parent: ${s.name}`);
      } else _.warn(`[Frame] Graphic behavior exists but mesh not found for ${this.sceneObject.name}`);
    } else _.debug("[Frame] No graphic behavior found, attaching frame to SceneObject transform");
    this.childMesh && (this.childMesh.parent = s, this.childMesh.position.z = -0.01, this.childMesh.rotationQuaternion && (this.childMesh.rotationQuaternion = null), this.applyOrientation(e?.orientation), _.debug(`[Frame] Attached to ${s.name}, z=${this.childMesh.position.z}`)), this.childMesh && (Object.keys(this.frameParts).length === 0 ? this.init() : this._applyColor(j(this._resolved.color, "Frame.color"))), e && (this.adjustFrame(e), this._fitObserver = e.onFitChangedObservable.add(() => this.adjustFrame(e)), this._orientationObserver = e.onOrientationChangedObservable.add((i) => this.applyOrientation(i)));
  }
  applyOrientation(t) {
    this.childMesh && (t === A.Horizontal ? this.childMesh.rotation = new f(-Math.PI / 2, 0, 0) : this.childMesh.rotation = new f(0, 0, 0));
  }
  adjustFrame(t) {
    _.debug("Adjusting frame"), Object.keys(this.frameParts).length !== 9 && _.error(`WRONG NUMBER OF FRAME PARTS! PROVIDED ${Object.keys(this.frameParts).length} parts instead of 9`);
    const e = this.frameParts, s = (this._resolved.borderWidth || 3) * 0.01, i = Ue, r = s / Xe, { sx: n, sy: o } = t.getFittedRect(), a = this.sceneObject.transform.scaling, c = Math.abs(a.x), l = Math.abs(t.orientation === A.Horizontal ? a.z : a.y), h = c > 0 && l > 0 ? r * l / c : r, d = e.Top, u = e.Bottom, m = e.Left, g = e.Right, p = e.Back, v = e["Top Right"], M = e["Top Left"], C = e["Bottom Left"], N = e["Bottom Right"];
    g && (_.debug("ADJUSTING RIGHT"), g.position = new f(0.5 * n, 0, 0), g.scaling = new f(h, o / i, g.scaling.z)), m && (m.position = new f(-0.5 * n, 0, 0), m.scaling = new f(h, o / i, m.scaling.z)), d && (d.position = new f(0, 0.5 * o, 0), d.scaling = new f(n / i, r, d.scaling.z)), u && (u.position = new f(0, -0.5 * o, 0), u.scaling = new f(n / i, r, u.scaling.z)), v && (v.position = new f(0.5 * n, 0.5 * o, 0), v.scaling = new f(h, r, v.scaling.z)), M && (M.position = new f(-0.5 * n, 0.5 * o, 0), M.scaling = new f(h, r, M.scaling.z)), C && (C.position = new f(-0.5 * n, -0.5 * o, 0), C.scaling = new f(h, r, C.scaling.z)), N && (N.position = new f(0.5 * n, -0.5 * o, 0), N.scaling = new f(h, r, N.scaling.z)), p && (p.scaling = new f(n / i, o / i, p.scaling.z));
  }
  onDetach() {
    _.debug("Detaching and disposing frame"), this._fitObserver?.remove(), this._fitObserver = null, this._orientationObserver?.remove(), this._orientationObserver = null, this._disposeFrame();
  }
  _disposeFrame() {
    if (Object.values(this.frameParts).forEach((t) => {
      if (t) try {
        t.dispose();
      } catch {
      }
    }), this.frameParts = {}, this._clonedMaterial?.dispose(), this._clonedMaterial = null, this._authoredAlbedo = null, this.childMesh) try {
      this.childMesh.dispose();
    } catch {
    }
    this.childMesh = null, this._containerPath && (this.resources.releaseContainer(this._containerPath), this._containerPath = void 0);
  }
};
async function ge(t) {
  const { fromBlob: e } = await import("./geotiff-BZSPixi_.js");
  return (await e(t)).getImage();
}
function Ve(t, e, s, i) {
  const r = new Uint8ClampedArray(e * s * 4);
  let n = 1 / 0, o = -1 / 0;
  for (let c = 0; c < t.length; c++) {
    const l = t[c];
    i !== null && l === i || (l < n && (n = l), l > o && (o = l));
  }
  isFinite(n) || (n = 0, o = 1);
  const a = o - n || 1;
  for (let c = 0; c < t.length; c++) {
    const l = t[c], h = c * 4;
    if (i !== null && l === i)
      r[h] = 0, r[h + 1] = 0, r[h + 2] = 0, r[h + 3] = 0;
    else {
      const d = Math.round((l - n) / a * 255);
      r[h] = d, r[h + 1] = d, r[h + 2] = d, r[h + 3] = 255;
    }
  }
  return r;
}
function qe(t, e, s, i) {
  t.length === 2 ? _.warn("[GeoTIFF] 2-band image — rendering as R=band0, G=band1, B=0. Consider single-band mode for luminance+mask data.") : t.length > 4 && _.warn(`[GeoTIFF] ${t.length}-band image — only first 4 bands used for RGBA display.`);
  const r = new Uint8ClampedArray(e * s * 4), n = t.length >= 4, o = i === 8, a = [];
  if (!o) for (const l of t) {
    let h = 1 / 0, d = -1 / 0;
    for (let u = 0; u < l.length; u++)
      l[u] < h && (h = l[u]), l[u] > d && (d = l[u]);
    isFinite(h) || (h = 0, d = 1), a.push({
      min: h,
      max: d,
      range: d - h || 1
    });
  }
  const c = e * s;
  for (let l = 0; l < c; l++) {
    const h = l * 4;
    for (let d = 0; d < 3; d++) {
      const u = t[d]?.[l] ?? 0;
      r[h + d] = o ? Math.min(255, Math.max(0, u)) : Math.round((u - a[d].min) / a[d].range * 255);
    }
    r[h + 3] = n ? o ? Math.min(255, Math.max(0, t[3][l])) : Math.round((t[3][l] - a[3].min) / a[3].range * 255) : 255;
  }
  return r;
}
async function me(t) {
  const e = t.getSamplesPerPixel(), s = t.getWidth(), i = t.getHeight(), r = await t.readRasters({ interleave: !1 }), n = [];
  if (Array.isArray(r) && r.length > 0 && ArrayBuffer.isView(r[0])) for (let o = 0; o < e; o++) n.push(r[o]);
  else {
    const o = r;
    for (let a = 0; a < e; a++) {
      const c = new o.constructor(s * i);
      for (let l = 0; l < s * i; l++) c[l] = o[l * e + a];
      n.push(c);
    }
  }
  return n;
}
function pe(t, e, s, i, r) {
  return t.length === 1 ? Ve(t[0], e, s, r) : qe(t, e, s, i);
}
function Ze(t) {
  let e = null, s = null, i = null;
  try {
    e = t.getOrigin();
  } catch {
  }
  try {
    s = t.getResolution();
  } catch {
  }
  try {
    i = t.getBoundingBox();
  } catch {
  }
  return {
    width: t.getWidth(),
    height: t.getHeight(),
    samplesPerPixel: t.getSamplesPerPixel(),
    bitsPerSample: t.getBitsPerSample(),
    geoKeys: t.getGeoKeys(),
    noData: t.getGDALNoData(),
    origin: e,
    resolution: s,
    bbox: i
  };
}
async function Ke(t) {
  const e = await ge(t), s = e.getWidth(), i = e.getHeight(), r = e.getGDALNoData(), n = pe(await me(e), s, i, e.getBitsPerSample(), r);
  let o = !1;
  try {
    o = e.getBoundingBox().length === 4;
  } catch {
  }
  return {
    rgba: n,
    width: s,
    height: i,
    isGeoReferenced: o
  };
}
async function Bt(t) {
  const e = await ge(t), s = Ze(e), i = await me(e);
  return {
    rgba: pe(i, s.width, s.height, s.bitsPerSample, s.noData),
    bands: i,
    metadata: s
  };
}
var zt = class extends Y {
  static behaviorType = "Image";
  quad = null;
  aspectRatio = 1;
  orientation = A.Vertical;
  texture = null;
  _settleGuard = null;
  getFitQuad() {
    return this.quad;
  }
  getFitMode() {
    return this._resolved.fit ?? "contain";
  }
  getCornerRadius() {
    return this._resolved.cornerRadius ?? 0;
  }
  getPill() {
    return this._resolved.pill === !0;
  }
  getBack() {
    return this._resolved.back ?? "none";
  }
  getBackColor() {
    return this._resolved.backColor ?? "#FFFFFF";
  }
  validate(t) {
    const e = [];
    return t.aspect !== void 0 && (typeof t.aspect != "number" || t.aspect <= 0) && e.push({
      field: "aspect",
      message: "Aspect ratio must be a positive number",
      code: "INVALID_ASPECT"
    }), this.validateFit(t.fit, e), this.validateCornerRadius(t.cornerRadius, e), this.validatePill(t.pill, e), this.validateBack(t.back, e), this.validateBackColor(t.backColor, e), e;
  }
  async applyCommit() {
    this.applyOrientation();
  }
  applyOrientation() {
    this.quad && (this.orientation = this._resolved.orientation ?? A.Vertical, this.orientation === A.Horizontal ? this.quad.rotation = new f(Math.PI / 2, Math.PI, 0) : this.quad.rotation = new f(0, Math.PI, 0), this.onOrientationChangedObservable.notifyObservers(this.orientation), this.updateQuadFit());
  }
  adoptAuthoredAspect() {
    const t = this._resolved.aspect;
    typeof t == "number" && t > 0 && (this.aspectRatio = t, this.aspectKnown = !0);
  }
  load() {
    const t = this.sceneObject.src, e = this.sceneObject.name;
    return _.debug(`loading image ${e}`), this.adoptAuthoredAspect(), t ? Ne(De.getFileExtensionFromSrc(t)) ? this.loadGeoTiff(t, e) : this.loadStandardImage(t, e) : (_.debug(`[Image] No src specified for ${e}`), Promise.resolve());
  }
  async loadGeoTiff(t, e) {
    this.setupQuad(e);
    const s = new k(`${e}_mat`, this.scene), i = this.resources.getAsset(t);
    if (!i) {
      _.warn(`[Image] GeoTIFF "${e}": no blob found for "${t}"`), s.disableLighting = !0, this.quad && (this.quad.material = s);
      return;
    }
    try {
      const { rgba: r, width: n, height: o, isGeoReferenced: a } = await Ke(i);
      _.debug(`[Image] GeoTIFF "${e}" decoded: ${n}x${o}, geoReferenced=${a}`);
      const c = ze.CreateRGBATexture(r, n, o, this.scene, !1, !1, L.BILINEAR_SAMPLINGMODE);
      this.texture = c, this.applyTextureToMaterial(c, s, e, n, o, !1), a && this._resolved.orientation !== A.Horizontal && await this.commit({ orientation: A.Horizontal });
    } catch (r) {
      _.warn(`[Image] GeoTIFF decode error for "${e}": ${r instanceof Error ? r.message : String(r)}`), s.disableLighting = !0, this.quad && (this.quad.material = s);
    }
  }
  loadStandardImage(t, e) {
    return new Promise((s, i) => {
      const r = setTimeout(() => {
        this._settleGuard === r && (this._settleGuard = null), _.warn(`[Image] "${e}" load did not settle in ${re / 1e3}s — continuing without texture confirmation`), s();
      }, re);
      this._settleGuard = r;
      const n = (o) => {
        clearTimeout(r), this._settleGuard === r && (this._settleGuard = null), o();
      };
      try {
        this.setupQuad(e);
        const o = new k(`${e}_mat`, this.scene), a = (l, h) => {
          _.warn(`[Image] Texture error for "${e}": ${l}`), o.disableLighting = !0, this.quad && (this.quad.material = o), n(s);
        }, c = t ? this.resources.getAsset(t) : void 0;
        if (_.debug(`[Image] "${e}" loading from ${c ? "blob" : "URL"}`), c) {
          const l = URL.createObjectURL(c);
          this.texture = new L(l, this.scene, !1, !1, L.BILINEAR_SAMPLINGMODE, void 0, a), this.texture.onLoadObservable.addOnce(() => {
            URL.revokeObjectURL(l), _.debug(`Revoked object URL for blob in ${e}`);
          });
        } else {
          const l = (t ? this.resources.resolveAssetUrl(t) : void 0) ?? t ?? "";
          this.texture = new L(l, this.scene, !1, !1, L.BILINEAR_SAMPLINGMODE, void 0, a);
        }
        if (this.texture) {
          const l = this.texture, h = async () => {
            try {
              const d = Re(t) || c !== void 0 && await Te(c);
              if (this.texture !== l) {
                n(s);
                return;
              }
              const u = l.getSize().width, m = l.getSize().height;
              this.applyTextureToMaterial(l, o, e, u, m, d), n(s);
            } catch (d) {
              n(() => i(d instanceof Error ? d : new Error(String(d))));
            }
          };
          l.isReady() ? h() : l.onLoadObservable.addOnce(() => {
            h();
          });
        } else n(() => i(/* @__PURE__ */ new Error("Image source element not found")));
      } catch (o) {
        n(() => i(o instanceof Error ? o : new Error(String(o))));
      }
    });
  }
  setupQuad(t) {
    this.quad = Ee.CreatePlane("IMAGE_PLANE", { size: 1 }, this.scene);
    const e = this.quad.getVerticesData("uv");
    if (e) {
      for (let s = 0; s < e.length; s += 2)
        e[s] = 1 - e[s], e[s + 1] = 1 - e[s + 1];
      this.quad.setVerticesData("uv", e);
    }
    this.sceneObject && this.sceneObject.transform && (_.debug("Setting quad as child of SceneObject transform"), this.quad.name = `${t}_mesh`, this.applyOrientation(), this.sceneObject.addChild(this.quad), this.watchNodeScaleForFit());
  }
  applyTextureToMaterial(t, e, s, i, r, n) {
    this.aspectRatio = i / r, this.aspectKnown = !0, _.debug(`[Image] "${s}" texture loaded, ${i}x${r}, aspect=${this.aspectRatio}`), this._resolved.aspect = this.aspectRatio, this.updateQuadFit(), this.onAspectChangedObservable.notifyObservers(this.aspectRatio), e.emissiveTexture = t, e.disableLighting = !0, n && (t.hasAlpha = !0, "getAlphaFromRGB" in t && (t.getAlphaFromRGB = !1), e.opacityTexture = t, e.transparencyMode = ke.MATERIAL_ALPHABLEND), this.quad && (_.debug(`Assigning material to quad for image ${s}`), this.quad.material = e);
  }
  onDetach() {
    this.disposeFitWatcher(), this.disposeBackCard(), this._settleGuard && (clearTimeout(this._settleGuard), this._settleGuard = null), this.quad && (this.quad = null), this.texture && (_.debug(`Disposing of the texture for image ${this.sceneObject.name}`), this.texture.dispose(), this.texture = null);
  }
};
function Ye(t, e) {
  return e <= 0 ? 0 : Math.exp(-t / e);
}
function U(t, e, s) {
  return e <= 0 ? 0 : t * e * (1 - Math.exp(-s / e));
}
function Qe(t, e, s) {
  return t * Ye(s, e);
}
var X = class {
  _samples = [];
  _windowMs;
  _staleMs;
  _minSpanMs;
  constructor(t = 120, e = 100, s = 20) {
    this._windowMs = t, this._staleMs = e, this._minSpanMs = s;
  }
  push(t, e) {
    this._samples.push({
      v: t,
      t: e
    });
    const s = e - this._windowMs;
    for (; this._samples.length > 0 && this._samples[0].t < s; ) this._samples.shift();
  }
  reset() {
    this._samples = [];
  }
  velocity(t) {
    const e = this._samples;
    if (e.length < 2) return 0;
    const s = e[e.length - 1];
    if (t - s.t > this._staleMs) return 0;
    let i = 0;
    const r = t - this._windowMs;
    for (; i < e.length - 1 && e[i].t < r; ) i++;
    const n = e[i], o = s.t - n.t;
    return o < this._minSpanMs ? 0 : (s.v - n.v) / (o / 1e3);
  }
}, de = 0.15, E = ee.FromHexString("#0984e3"), Je = 0.35, et = 0.6, $ = new $e(0.035, 0.518, 0.89, 0.5), ue = 0.01, fe = 10, tt = 0.1, st = 0.5;
function V(t, e) {
  return Math.round(t / e) * e;
}
function it(t) {
  return !t || t.length === 0 ? !0 : t.includes("x") || t.includes("z");
}
var O = null, q = /* @__PURE__ */ new Map(), Gt = class {
  onDragStartObservable = new le();
  onDragEndObservable = new le();
  _target;
  _scene;
  _options;
  _enabled = !1;
  _disposed = !1;
  _pointerObserver = null;
  _utilPointerObserver = null;
  _isDragging = !1;
  _isDraggingCircle = !1;
  _dragPlane = null;
  _dragStartWorldPos = null;
  _dragStartNodePos = null;
  _dragPointerId = null;
  _cmdDragXZPlane = null;
  _cmdDragActive = !1;
  _snapAccumulator = f.Zero();
  _velPX = new X();
  _velPY = new X();
  _velPZ = new X();
  _glideObserver = null;
  _glide = null;
  _utilityLayer = null;
  _circleDisc = null;
  _circleRing = null;
  _connectorLine = null;
  _circleMaterial = null;
  _circleHoverMaterial = null;
  _beforeRenderObserver = null;
  _circleHovered = !1;
  constructor(t, e, s) {
    this._target = t, this._scene = e, this._options = {
      groundCircle: !0,
      ...s
    };
  }
  get enabled() {
    return this._enabled;
  }
  set enabled(t) {
    this._disposed || t === this._enabled || (this._enabled = t, t ? this._activate() : this._deactivate());
  }
  setOptions(t) {
    this._options = {
      ...this._options,
      ...t
    }, this._enabled && (this._teardownGroundCircle(), this._showsGroundCircle() && this._setupGroundCircle());
  }
  dispose() {
    this._disposed || (this._disposed = !0, this._enabled = !1, this._deactivate(), this.onDragStartObservable.clear(), this.onDragEndObservable.clear());
  }
  _activate() {
    q.set(this._target, this), this._setupPointerObserver(), this._showsGroundCircle() && this._setupGroundCircle();
  }
  _showsGroundCircle() {
    return this._options.groundCircle !== !1 && it(this._options.axes);
  }
  _deactivate() {
    q.delete(this._target), this._endDrag(), this._cancelGlide(), this._teardownPointerObserver(), this._teardownGroundCircle();
  }
  _setupPointerObserver() {
    this._pointerObserver || (this._pointerObserver = this._scene.onPointerObservable.add((t) => {
      switch (t.type) {
        case R.POINTERDOWN: {
          if (t.event.button !== 0 || this._isDragging || O) return;
          const e = t.pickInfo;
          if (!e?.hit || !e.pickedMesh) return;
          this._isMeshOfTarget(e.pickedMesh) && this._startCameraPlaneDrag(t);
          break;
        }
        case R.POINTERMOVE:
          if (!this._isDragging || this._isDraggingCircle || this._getPointerId(t) !== this._dragPointerId) return;
          this._updateCameraPlaneDrag(t);
          break;
        case R.POINTERUP:
          if (!this._isDragging || this._getPointerId(t) !== this._dragPointerId) return;
          this._endDrag();
          break;
      }
    }));
  }
  _teardownPointerObserver() {
    this._pointerObserver && (this._scene.onPointerObservable.remove(this._pointerObserver), this._pointerObserver = null), this._utilPointerObserver && this._utilityLayer && (this._utilityLayer.utilityLayerScene.onPointerObservable.remove(this._utilPointerObserver), this._utilPointerObserver = null);
  }
  _getPointerId(t) {
    return t.event.pointerId ?? 0;
  }
  _startCameraPlaneDrag(t) {
    if (O && O !== this) return;
    const e = this._scene.activeCamera;
    if (!e) return;
    const s = e.getForwardRay().direction.normalize(), i = this._target.getAbsolutePosition();
    this._dragPlane = H.FromPositionAndNormal(i, s), this._isDraggingCircle = !1, this._cmdDragXZPlane = H.FromPositionAndNormal(new f(0, i.y, 0), f.Up()), this._cmdDragActive = t.event.metaKey;
    const r = this._cmdDragActive ? this._cmdDragXZPlane : this._dragPlane, n = this._pickOnPlane(t, r);
    n && (this._dragStartWorldPos = n, this._dragStartNodePos = this._target.position.clone(), this._resetMomentumTracking(), this._dragPointerId = this._getPointerId(t), this._isDragging = !0, this._snapAccumulator.setAll(0), O = this, this._detachCamera(), this._options.onGrab?.(), this.onDragStartObservable.notifyObservers());
  }
  _updateCameraPlaneDrag(t) {
    if (!this._dragPlane || !this._dragStartWorldPos || !this._dragStartNodePos) return;
    const e = t.event.metaKey;
    if (e !== this._cmdDragActive) {
      this._cmdDragActive = e;
      const n = e ? this._cmdDragXZPlane : this._dragPlane, o = this._pickOnPlane(t, n);
      o && (this._dragStartWorldPos = o, this._dragStartNodePos = this._target.position.clone(), this._resetMomentumTracking(), this._snapAccumulator.setAll(0));
    }
    const s = e ? this._cmdDragXZPlane : this._dragPlane, i = this._pickOnPlane(t, s);
    if (!i) return;
    const r = i.subtract(this._dragStartWorldPos);
    e ? r.y = 0 : this._remapToHybridDelta(r), this._applyDelta(r, t);
  }
  _remapToHybridDelta(t) {
    const e = this._scene.activeCamera;
    if (!e) return;
    const s = e.getWorldMatrix(), i = f.TransformNormal(f.Right(), s), r = f.TransformNormal(f.Up(), s);
    i.normalize(), r.normalize();
    const n = f.Dot(t, i), o = f.Dot(t, r), a = new f(i.x, 0, i.z), c = a.length();
    c > 1e-3 ? a.scaleInPlace(1 / c) : a.set(1, 0, 0), t.set(a.x * n, o, a.z * n);
  }
  _startGroundCircleDrag(t) {
    if (O && O !== this) return;
    this._dragPlane = H.FromPositionAndNormal(f.Zero(), f.Up()), this._isDraggingCircle = !0;
    const e = this._pickOnPlane(t);
    e && (this._dragStartWorldPos = e, this._dragStartNodePos = this._target.position.clone(), this._resetMomentumTracking(), this._dragPointerId = this._getPointerId(t), this._isDragging = !0, this._snapAccumulator.setAll(0), O = this, this._detachCamera(), this._options.onGrab?.(), this.onDragStartObservable.notifyObservers());
  }
  _updateGroundCircleDrag(t) {
    if (!this._dragPlane || !this._dragStartWorldPos || !this._dragStartNodePos) return;
    const e = this._pickOnPlane(t);
    if (!e) return;
    const s = e.subtract(this._dragStartWorldPos);
    s.y = 0, this._applyDelta(s, t);
  }
  _isSnapActive(t) {
    return this._options.snap ? t.event.altKey : !1;
  }
  _applyDelta(t, e) {
    const s = this._options.axes;
    s && s.length > 0 && (s.includes("x") || (t.x = 0), s.includes("y") || (t.y = 0), s.includes("z") || (t.z = 0));
    let i = t;
    const r = this._target.parent;
    if (r) {
      const n = r.getWorldMatrix(), o = ae.Invert(n);
      i = f.TransformNormal(t, o);
    }
    if (e && this._options.snap && this._isSnapActive(e)) {
      const n = e.event.shiftKey ? st : tt, o = this._dragStartNodePos.add(i);
      this._snapAccumulator.copyFrom(o);
      const a = new f(V(this._snapAccumulator.x, n), V(this._snapAccumulator.y, n), V(this._snapAccumulator.z, n));
      this._target.position = a;
    } else this._target.position = this._dragStartNodePos.add(i);
    if (this._momentumEnabled()) {
      const n = performance.now();
      this._velPX.push(this._target.position.x, n), this._velPY.push(this._target.position.y, n), this._velPZ.push(this._target.position.z, n);
    }
  }
  _pickOnPlane(t, e) {
    const s = e ?? this._dragPlane, i = this._scene.activeCamera;
    if (!i || !s) return null;
    const r = t.pickInfo?.ray ?? this._scene.createPickingRay(t.event.offsetX, t.event.offsetY, ae.Identity(), i), n = r.intersectsPlane(s);
    return n === null || n < 0 ? null : r.origin.add(r.direction.scale(n));
  }
  _endDrag() {
    this._isDragging && (this._maybeStartGlide(), this._isDragging = !1, O = null, this._isDraggingCircle = !1, this._dragPlane = null, this._dragStartWorldPos = null, this._dragStartNodePos = null, this._dragPointerId = null, this._cmdDragXZPlane = null, this._cmdDragActive = !1, this._snapAccumulator.setAll(0), this._reattachCamera(), this.onDragEndObservable.notifyObservers());
  }
  _momentumEnabled() {
    const t = this._options.momentumDamping ?? 0;
    return Number.isFinite(t) && t > 0;
  }
  _resetMomentumTracking() {
    if (this._cancelGlide(), this._velPX.reset(), this._velPY.reset(), this._velPZ.reset(), !this._momentumEnabled()) return;
    const t = performance.now();
    this._velPX.push(this._target.position.x, t), this._velPY.push(this._target.position.y, t), this._velPZ.push(this._target.position.z, t);
  }
  _maybeStartGlide() {
    if (!this._momentumEnabled()) return;
    const t = performance.now(), e = new f(this._velPX.velocity(t), this._velPY.velocity(t), this._velPZ.velocity(t)), s = e.length();
    s < ue || (s > fe && e.scaleInPlace(fe / s), this._startGlideWithVelocity(e, t));
  }
  _startGlideWithVelocity(t, e) {
    this._cancelGlide(), this._glide = {
      startPos: this._target.position.clone(),
      v: t.clone(),
      tau: this._options.momentumDamping ?? 0,
      startTime: e
    }, this._glideObserver = this._scene.onBeforeRenderObservable.add(() => this._glideStep());
  }
  _glideStep() {
    const t = this._glide;
    if (!t) return;
    const e = (performance.now() - t.startTime) / 1e3, s = Math.abs(Qe(t.v.length(), t.tau, e));
    this._target.position.set(t.startPos.x + U(t.v.x, t.tau, e), t.startPos.y + U(t.v.y, t.tau, e), t.startPos.z + U(t.v.z, t.tau, e)), s < ue && this._cancelGlide();
  }
  _cancelGlide() {
    this._glideObserver && (this._scene.onBeforeRenderObservable.remove(this._glideObserver), this._glideObserver = null), this._glide = null;
  }
  _detachCamera() {
    const t = this._scene.activeCamera;
    t && t.detachControl();
  }
  _reattachCamera() {
    const t = this._scene.activeCamera, e = this._scene.getEngine().getRenderingCanvas();
    t && e && t.attachControl(e, !0);
  }
  _isMeshOfTarget(t) {
    let e = t;
    for (; e; ) {
      if (q.has(e)) return e === this._target;
      e = e.parent;
    }
    return !1;
  }
  _isGroundCircleMesh(t) {
    return t === this._circleDisc || t === this._circleRing;
  }
  _setupGroundCircle() {
    if (this._circleDisc) return;
    this._utilityLayer = new Ge(this._scene), this._utilityLayer.utilityLayerScene.autoClearDepthAndStencil = !1;
    const t = this._utilityLayer.utilityLayerScene;
    this._utilPointerObserver = t.onPointerObservable.add((e) => {
      switch (e.type) {
        case R.POINTERDOWN: {
          if (e.event.button !== 0 || this._isDragging || O) return;
          const s = e.pickInfo;
          if (!s?.hit || !s.pickedMesh) return;
          this._isGroundCircleMesh(s.pickedMesh) && this._startGroundCircleDrag(e);
          break;
        }
        case R.POINTERMOVE:
          if (this._isDragging) {
            if (!this._isDraggingCircle || this._getPointerId(e) !== this._dragPointerId) return;
            this._updateGroundCircleDrag(e);
          } else {
            const s = e.pickInfo, i = !!(s?.hit && s.pickedMesh && this._isGroundCircleMesh(s.pickedMesh));
            i !== this._circleHovered && (this._circleHovered = i, this._updateCircleHoverState());
          }
          break;
        case R.POINTERUP:
          if (!this._isDragging || !this._isDraggingCircle || this._getPointerId(e) !== this._dragPointerId) return;
          this._endDrag();
          break;
      }
    }), this._circleMaterial = new k("dragToMove_circleMat", t), this._circleMaterial.diffuseColor = E, this._circleMaterial.alpha = Je, this._circleMaterial.backFaceCulling = !1, this._circleMaterial.disableLighting = !0, this._circleMaterial.emissiveColor = E, this._circleHoverMaterial = new k("dragToMove_circleHoverMat", t), this._circleHoverMaterial.diffuseColor = E, this._circleHoverMaterial.alpha = et, this._circleHoverMaterial.backFaceCulling = !1, this._circleHoverMaterial.disableLighting = !0, this._circleHoverMaterial.emissiveColor = E, this._circleDisc = je("dragToMove_disc", {
      radius: de,
      tessellation: 48
    }, t), this._circleDisc.material = this._circleMaterial, this._circleDisc.isPickable = !0, this._circleDisc.rotation.x = Math.PI / 2, this._circleRing = He("dragToMove_ring", {
      diameter: de * 2,
      thickness: 5e-3,
      tessellation: 48
    }, t), this._circleRing.material = this._circleMaterial, this._circleRing.isPickable = !0, this._updateGroundCirclePositions(), this._createConnectorLine(t), this._beforeRenderObserver = this._scene.onBeforeRenderObservable.add(() => {
      this._updateGroundCirclePositions();
    });
  }
  _createConnectorLine(t) {
    const e = this._target.getAbsolutePosition(), s = new f(e.x, 0, e.z);
    this._connectorLine = he("dragToMove_connector", {
      points: [e, s],
      updatable: !0
    }, t), this._connectorLine.color = new ee($.r, $.g, $.b), this._connectorLine.alpha = $.a, this._connectorLine.isPickable = !1;
  }
  _updateGroundCirclePositions() {
    const t = this._target.getAbsolutePosition(), e = new f(t.x, 1e-3, t.z);
    this._circleDisc && this._circleDisc.position.copyFrom(e), this._circleRing && this._circleRing.position.set(e.x, 2e-3, e.z), this._connectorLine && (this._connectorLine = he("dragToMove_connector", {
      points: [t, e],
      instance: this._connectorLine
    }));
  }
  _updateCircleHoverState() {
    const t = this._circleHovered ? this._circleHoverMaterial : this._circleMaterial;
    this._circleDisc && t && (this._circleDisc.material = t), this._circleRing && t && (this._circleRing.material = t);
    const e = this._scene.getEngine().getRenderingCanvas();
    e && (e.style.cursor = this._circleHovered ? "grab" : "");
  }
  _teardownGroundCircle() {
    this._beforeRenderObserver && (this._scene.onBeforeRenderObservable.remove(this._beforeRenderObserver), this._beforeRenderObserver = null), this._utilPointerObserver && this._utilityLayer && (this._utilityLayer.utilityLayerScene.onPointerObservable.remove(this._utilPointerObserver), this._utilPointerObserver = null), this._connectorLine?.dispose(), this._connectorLine = null, this._circleDisc?.dispose(), this._circleDisc = null, this._circleRing?.dispose(), this._circleRing = null, this._circleMaterial?.dispose(), this._circleMaterial = null, this._circleHoverMaterial?.dispose(), this._circleHoverMaterial = null, this._utilityLayer && (this._utilityLayer.dispose(), this._utilityLayer = null), this._circleHovered = !1;
  }
}, Q = "corner radius", be = "outer corner radius", ve = "stroke";
function Z(t) {
  const e = t.trim().toLowerCase();
  return e === Q || e === be || e === ve;
}
var rt = class extends J {
  static behaviorType = "MeshBackground";
  _meshes = [];
  _rels = /* @__PURE__ */ new Map();
  _restMin = 0;
  _warned = /* @__PURE__ */ new Set();
  _preAttachInfluences = /* @__PURE__ */ new Map();
  validate(t) {
    const e = [], s = t.cornerRadius;
    s !== void 0 && (typeof s != "number" || !Number.isFinite(s) || s < 0) && e.push({
      field: "cornerRadius",
      message: "cornerRadius must be a non-negative number (meters)",
      code: "INVALID_RADIUS"
    });
    const i = t.pill;
    return i !== void 0 && typeof i != "boolean" && e.push({
      field: "pill",
      message: "pill must be a boolean",
      code: "INVALID_PILL"
    }), e;
  }
  onAttach() {
    this._resolveMeshes() && this._captureShapeInfluences(), this._apply();
  }
  async applyCommit() {
    this._apply();
  }
  refreshShape() {
    this.attachedNode && this._apply();
  }
  onDetach() {
    for (const t of this._meshes) {
      if (t.isDisposed()) continue;
      const e = t.morphTargetManager;
      if (!e) continue;
      const s = this._preAttachInfluences.get(t);
      for (let i = 0; i < e.numTargets; i++) {
        const r = e.getTarget(i);
        r && Z(r.name) && (r.influence = s?.get(r.name.trim().toLowerCase()) ?? 0);
      }
    }
    this._meshes = [], this._rels.clear(), this._restMin = 0, this._warned.clear(), this._preAttachInfluences.clear();
  }
  _captureShapeInfluences() {
    this._preAttachInfluences.clear();
    for (const t of this._meshes) {
      const e = t.morphTargetManager;
      if (!e) continue;
      const s = /* @__PURE__ */ new Map();
      for (let i = 0; i < e.numTargets; i++) {
        const r = e.getTarget(i);
        r && Z(r.name) && s.set(r.name.trim().toLowerCase(), r.influence);
      }
      this._preAttachInfluences.set(t, s);
    }
  }
  _warnOnce(t, e) {
    this._warned.has(t) || (this._warned.add(t), _.warn(e));
  }
  _apply() {
    if (!this._resolveMeshes() || !(this._restMin > 0)) return;
    const t = this._resolved.pill === !0, e = typeof this._resolved.cornerRadius == "number" && this._resolved.cornerRadius > 0 ? this._resolved.cornerRadius : 0, s = t ? 1 : 2 * e / this._restMin;
    !t && s > 1 && this._warnOnce(`reach:${e}`, `[MeshBackground] "${this.sceneObject.name}" cornerRadius ${e} exceeds the morphs' reach (${(this._restMin / 2).toFixed(3)} m — half the rest box's smaller side); saturating`);
    const i = this._measureMinXY(!0);
    t && i > this._restMin + 1e-6 && this._warnOnce("pill:over-rest", `[MeshBackground] "${this.sceneObject.name}" pill: smaller side ${i.toFixed(3)} m exceeds rest ${this._restMin.toFixed(3)} m; corner radius tops out at ${(this._restMin / 2).toFixed(3)} m (morph reach), ends are rounded, not full semicircles`);
    const r = i > 0 ? Math.max(0, Math.min(1, i / this._restMin)) : 1, n = Math.min(1, s, r);
    for (const o of this._meshes) {
      const a = o.morphTargetManager;
      if (a)
        for (let c = 0; c < a.numTargets; c++) {
          const l = a.getTarget(c);
          if (!l) continue;
          const h = l.name.trim().toLowerCase();
          h === Q ? l.influence = n : (h === be || h === ve) && (l.influence = 0);
        }
    }
    for (const o of this._meshes)
      o.computeWorldMatrix(!0), o.refreshBoundingInfo(!1, !0);
  }
  _resolveMeshes() {
    if (this._meshes.length && this._meshes.every((i) => !i.isDisposed())) return !0;
    const t = this.sceneObject.getOwnedMeshes().filter((i) => i instanceof _e);
    if (!t.length)
      return this._warnOnce("nomesh", `[MeshBackground] "${this.sceneObject.name}" has no meshes`), !1;
    if (!t.some((i) => {
      const r = i.morphTargetManager;
      if (!r) return !1;
      for (let n = 0; n < r.numTargets; n++) {
        const o = r.getTarget(n);
        if (o && o.name.trim().toLowerCase() === Q) return !0;
      }
      return !1;
    }))
      return this._warnOnce("norig", `[MeshBackground] "${this.sceneObject.name}" has no "Corner Radius" morph — this asset is not a rounded-background rig (use Bevel for plain primitives)`), !1;
    this._meshes = t;
    const e = this.sceneObject.transform;
    e.computeWorldMatrix(!0);
    const s = e.getWorldMatrix().clone().invert();
    this._rels.clear();
    for (const i of t)
      i.computeWorldMatrix(!0), this._rels.set(i, i.getWorldMatrix().multiply(s));
    return this._restMin = this._measureMinXY(!1, !0), !0;
  }
  _measureMinXY(t, e = !1) {
    const s = [];
    for (const o of this._meshes) {
      const a = o.morphTargetManager;
      if (!a) continue;
      const c = /* @__PURE__ */ new Map();
      for (let l = 0; l < a.numTargets; l++) {
        const h = a.getTarget(l);
        h && (e || t && Z(h.name)) && (c.set(h.name, h.influence), h.influence = 0);
      }
      s.push([o, c]);
    }
    const i = new f(1 / 0, 1 / 0, 1 / 0), r = new f(-1 / 0, -1 / 0, -1 / 0), n = new f();
    for (const o of this._meshes) {
      o.refreshBoundingInfo(!1, !0);
      const a = this._rels.get(o);
      if (!a) continue;
      const c = o.getBoundingInfo().boundingBox;
      for (const l of c.vectors)
        f.TransformCoordinatesToRef(l, a, n), i.minimizeInPlace(n), r.maximizeInPlace(n);
    }
    for (const [o, a] of s) {
      const c = o.morphTargetManager;
      if (c)
        for (const [l, h] of a) {
          const d = c.getTargetByName(l);
          d && (d.influence = h);
        }
    }
    return Number.isFinite(i.x) ? Math.min(r.x - i.x, r.y - i.y) : 0;
  }
};
function nt(t, e) {
  let s = -1 / 0, i = 1 / 0, r = -1 / 0, n = 1 / 0;
  for (const { positions: o, indices: a, toRoot: c } of t) {
    const l = c.m, h = new Float64Array(o.length / 3), d = new Float64Array(h.length);
    for (let u = 0; u < h.length; u++) {
      const m = o[u * 3], g = o[u * 3 + 1], p = o[u * 3 + 2];
      h[u] = l[0] * m + l[4] * g + l[8] * p + l[12], d[u] = l[1] * m + l[5] * g + l[9] * p + l[13];
    }
    for (let u = 0; u + 2 < a.length; u += 3) for (let m = 0; m < 3; m++) {
      const g = a[u + m], p = a[u + (m + 1) % 3];
      if ((d[g] - e.y) * (d[p] - e.y) <= 0 && d[g] !== d[p]) {
        const v = h[g] + (h[p] - h[g]) * ((e.y - d[g]) / (d[p] - d[g]));
        v <= e.x ? s = Math.max(s, v) : i = Math.min(i, v);
      }
      if ((h[g] - e.x) * (h[p] - e.x) <= 0 && h[g] !== h[p]) {
        const v = d[g] + (d[p] - d[g]) * ((e.x - h[g]) / (h[p] - h[g]));
        v <= e.y ? r = Math.max(r, v) : n = Math.min(n, v);
      }
    }
  }
  return Number.isFinite(s) && Number.isFinite(i) && Number.isFinite(r) && Number.isFinite(n) ? {
    x: i - s,
    y: n - r
  } : null;
}
function ot(t, e, s) {
  const i = [], r = [];
  for (let c = 0; c < t.length; c++) t[c] < -1e-3 ? i.push(c) : t[c] > 1e-3 && r.push(c);
  if (!i.length || !r.length) return 1 / 0;
  const n = (c) => {
    let l = 1 / 0, h = -1 / 0;
    for (const d of r) l = Math.min(l, t[d] + c * e[d]);
    for (const d of i) h = Math.max(h, t[d] + c * e[d]);
    return l - h;
  };
  if (!(n(s) <= 1e-3)) return 1 / 0;
  let o = 0, a = s;
  for (let c = 0; c < 48; c++) {
    const l = (o + a) / 2;
    n(l) > 1e-3 ? o = l : a = l;
  }
  return o;
}
var x = [
  {
    axis: "X",
    key: "x",
    field: "width",
    innerField: "innerWidth"
  },
  {
    axis: "Y",
    key: "y",
    field: "height",
    innerField: "innerHeight"
  },
  {
    axis: "Z",
    key: "z",
    field: "depth",
    innerField: "innerDepth"
  }
];
function K(t) {
  const e = t.match(/^([XYZ])([pn])?_?(In|Out)$/i);
  return e ? {
    axis: e[1].toUpperCase(),
    isIn: e[3].toLowerCase() === "in"
  } : null;
}
var jt = class b extends J {
  static behaviorType = "MorphStretch";
  _meshes = [];
  _axisGroups = /* @__PURE__ */ new Map();
  _baseSize = null;
  _restCentre = null;
  _axisDeltas = /* @__PURE__ */ new Map();
  _restStates = /* @__PURE__ */ new Map();
  _seamMin = /* @__PURE__ */ new Map();
  _resolvedSize = null;
  _warnedAxes = /* @__PURE__ */ new Set();
  _restIsBase = !1;
  static MAX_INFLUENCE = 10;
  static MIN_SHRINK_FRACTION = 0.01;
  static MIN_OPENING_FRACTION = 0.5;
  constructor(e, s) {
    super(e, s), this.validate(this.getAuthored()), this._resolved = this._resolveAll();
  }
  validate(e) {
    const s = [], i = e.fit;
    i === "stretch" ? e.fit = "fill" : i !== void 0 && i !== "fill" && i !== "contain" && (delete e.fit, s.push({
      field: "fit",
      message: "fit must be 'fill' or 'contain'",
      code: "INVALID_FIT"
    }));
    for (const { field: o } of x) {
      const a = e[o];
      typeof a == "string" && we(a) || a !== void 0 && (typeof a != "number" || !Number.isFinite(a) || a <= 0) && s.push({
        field: o,
        message: `${o} must be a positive number (meters) or a property binding`,
        code: "INVALID_SIZE"
      });
    }
    for (const { innerField: o } of x) {
      const a = e[o];
      a !== void 0 && (typeof a != "number" || !Number.isFinite(a) || a <= 0) && s.push({
        field: o,
        message: `${o} must be a positive number (meters)`,
        code: "INVALID_INNER"
      });
    }
    const r = e.weight;
    r !== void 0 && (typeof r != "number" || !Number.isFinite(r) || r <= 0) && s.push({
      field: "weight",
      message: "weight must be a positive number",
      code: "INVALID_WEIGHT"
    });
    const n = e.range;
    return n !== void 0 && !(Array.isArray(n) && n.length === 2 && n.every((o) => typeof o == "number" && Number.isFinite(o) && o > 0) && n[0] <= n[1]) && s.push({
      field: "range",
      message: "range must be [min, max] positive multiples of the inner reference, min ≤ max",
      code: "INVALID_RANGE"
    }), s;
  }
  _sizeOf(e, s = this._resolved) {
    const i = s[e];
    return typeof i == "number" && Number.isFinite(i) && i > 0 ? i : void 0;
  }
  _innerOf(e, s = this._resolved) {
    const i = s[e];
    return typeof i == "number" && Number.isFinite(i) && i > 0 ? i : void 0;
  }
  _weight(e = this._resolved) {
    const s = e.weight;
    return typeof s == "number" && Number.isFinite(s) && s > 0 ? s : 1;
  }
  _range(e = this._resolved) {
    const s = e.range;
    return Array.isArray(s) && s.length === 2 && s.every((i) => typeof i == "number" && Number.isFinite(i) && i > 0) && s[0] <= s[1] ? [s[0], s[1]] : null;
  }
  getLayoutContentCenter() {
    return x.some(({ innerField: e }) => this._innerOf(e) !== void 0) ? {
      x: 0,
      y: 0,
      z: 0
    } : null;
  }
  layoutContentFrame = "node";
  getLayoutContentSize() {
    const e = this._sizeOf("width"), s = this._sizeOf("height"), i = this._sizeOf("depth");
    if (e === void 0 && s === void 0 && i === void 0) return null;
    const r = this._baseSize;
    return !r && (e === void 0 || s === void 0 || i === void 0) ? null : {
      x: e ?? r.x,
      y: s ?? r.y,
      z: i ?? r.z
    };
  }
  getStretchCapability() {
    const e = this._baseSize;
    if (!e) return null;
    const s = {
      X: e.x,
      Y: e.y,
      Z: e.z
    }, i = {};
    for (const { axis: r, innerField: n } of x) {
      const o = s[r], a = this._axisGroups.get(r), c = this._axisDeltas.get(r) ?? {
        outDelta: 0,
        inDelta: 0
      }, l = !!a?.outNames.length && c.outDelta > 1e-4, h = this._canShrink(r);
      i[r] = {
        rest: o,
        via: l || h ? "morph" : "scale",
        canGrow: l,
        canShrink: h,
        min: h ? Math.max(0, o - c.inDelta * b.MAX_INFLUENCE) : o,
        max: l ? o + c.outDelta * b.MAX_INFLUENCE : o
      };
      const d = this._innerOf(n);
      d !== void 0 && (i[r].inner = d);
      const u = this._floorBox(r, o, d);
      u !== void 0 && (i[r].floor = u);
    }
    return i;
  }
  setResolvedSize(e) {
    this._resolvedSize && this._resolvedSize.x === e.x && this._resolvedSize.y === e.y && this._resolvedSize.z === e.z || (this._resolvedSize && ne(this.sceneObject), this._resolvedSize = new f(e.x, e.y, e.z), this._apply());
  }
  getRestOpening() {
    const e = this._restCentre, s = this._baseSize;
    if (!e || !s) return null;
    const i = nt(this._meshes.flatMap((n) => {
      const o = this._restStates.get(n), a = n.getVerticesData(W.PositionKind), c = n.getIndices();
      return o && !o.isBackground && a && c ? [{
        positions: a,
        indices: c,
        toRoot: o.rel
      }] : [];
    }), e), r = b.MIN_OPENING_FRACTION;
    return i && s.x > 0 && s.y > 0 && i.x > s.x * r && i.y > s.y * r ? i : null;
  }
  getResolvedSize() {
    const e = this._resolvedSize;
    return e && {
      x: e.x,
      y: e.y,
      z: e.z
    };
  }
  getRestScaling(e) {
    const s = this._restStates.get(e);
    return s ? s.scaling.clone() : null;
  }
  showBaseSizeForBake() {
    const e = oe(() => this._resolveAll());
    return JSON.stringify(e) === JSON.stringify(this._resolved) ? null : (this._resolved = e, this._apply(), () => {
      this._resolved = this._resolveAll(), this._apply();
    });
  }
  clearResolvedSize() {
    this._resolvedSize && (ne(this.sceneObject), this._resolvedSize = null, this._apply());
  }
  onAttach() {
    this._apply();
  }
  async applyCommit(e, s) {
    this._apply();
    const i = this.getAuthored();
    [
      "width",
      "height",
      "depth"
    ].some((r) => e[r] !== void 0 || s[r] !== i[r]) && Ie(this.sceneObject);
  }
  onDetach() {
    for (const e of this._meshes) {
      if (e.isDisposed()) continue;
      const s = this._restStates.get(e);
      s && e.scaling.copyFrom(s.scaling);
      const i = e.morphTargetManager;
      if (i)
        for (let r = 0; r < i.numTargets; r++) {
          const n = i.getTarget(r);
          n && K(n.name) && (n.influence = 0);
        }
    }
    this._meshes = [], this._axisGroups.clear(), this._baseSize = null, this._restCentre = null, this._axisDeltas.clear(), this._restStates.clear(), this._seamMin.clear(), this._resolvedSize = null, this._warnedAxes.clear(), this._restIsBase = !1;
  }
  _warnOnce(e, s) {
    this._warnedAxes.has(e) || (this._warnedAxes.add(e), _.warn(s));
  }
  _canShrink(e) {
    return !!this._axisGroups.get(e)?.inNames.length && (this._axisDeltas.get(e)?.inDelta ?? 0) > 1e-4;
  }
  _shrinkFloor(e, s) {
    return this._canShrink(e) ? s * b.MIN_SHRINK_FRACTION : s;
  }
  _seamFloor(e, s, i) {
    return i && s !== void 0 ? 0 : this._seamMin.get(e) ?? 0;
  }
  _floorBox(e, s, i) {
    const r = this._seamFloor(e, i, this._range());
    if (r > s * b.MIN_SHRINK_FRACTION)
      return Math.max(0, this._weight() * (r - (i === void 0 ? 0 : s - i)));
  }
  static _fillTarget(e, s, i, r, n, o) {
    let a = e / r, c = 1;
    if (i !== void 0 && n) {
      const u = Math.min(n[1] * i, Math.max(n[0] * i, a));
      c = a / u, a = u;
    }
    const l = c * r, h = i === void 0 ? a : a + (s - i), d = Math.max(h, o);
    return {
      outer: h,
      desired: d,
      extra: l,
      scale: (n && i !== void 0 ? 1 : d / s) * l
    };
  }
  _apply() {
    if (!this._resolveMeshes()) return;
    const e = this._baseSize;
    if (!e) return;
    if (this._resolved.fit === "contain") {
      this._applyContain(e);
      return;
    }
    const s = this._restIsBase ? oe(() => this._resolveAll()) : null, i = this._weight(), r = this._range();
    for (const { axis: n, key: o, field: a, innerField: c } of x) {
      const l = this._innerOf(c), h = s && l !== void 0 ? null : this._resolvedSize, d = h ? h[o] > 0 ? h[o] : void 0 : this._sizeOf(a);
      if (d === void 0) {
        this._resetAxis(n, o);
        continue;
      }
      const u = e[o];
      if (!(u > 0)) continue;
      const m = this._seamFloor(n, l, r), g = Math.max(u * b.MIN_SHRINK_FRACTION, m), p = h ? Math.max(this._shrinkFloor(n, u), m) : g, { outer: v, desired: M, extra: C, scale: N } = b._fillTarget(d, u, l, i, r, p);
      let B = N;
      if (s && !h) {
        const y = this._sizeOf(a, s);
        y !== void 0 && (B /= b._fillTarget(y, u, this._innerOf(c, s), this._weight(s), this._range(s), g).scale);
      }
      const Me = m > u * b.MIN_SHRINK_FRACTION;
      (h || Me) && v < p && !(r && l !== void 0) && this._warnOnce(`${n}:floor`, `[MorphStretch] "${this.sceneObject.name}" ${n} ${h ? "slot" : "size"} ${v.toFixed(3)} is below the asset's floor ${p.toFixed(3)}; holding the floor (geometry overhangs its box)`);
      const S = this._axisGroups.get(n);
      if (!S) {
        for (const y of this._meshes) {
          const I = this._restStates.get(y);
          y.scaling[o] = (I ? I.scaling[o] : 1) * B;
        }
        continue;
      }
      const te = this._axisDeltas.get(n) ?? {
        outDelta: 0,
        inDelta: 0
      }, P = M > u, D = P ? te.outDelta : te.inDelta, ye = D > 1e-4, se = P ? S.outNames : S.inNames, Pe = P ? S.inNames : S.outNames;
      if (M !== u && !ye) {
        se.length ? this._warnOnce(`${n}:degenerate`, `[MorphStretch] "${this.sceneObject.name}" ${n} ${P ? "Out" : "In"} morphs displace no vertices; treating the axis as morphless (scale fallback)`) : this._warnOnce(`${n}:missing`, `[MorphStretch] "${this.sceneObject.name}" ${n} has no ${P ? "Out" : "In"} morphs; reaching ${a}=${M} by scaling (detail stretches)`);
        for (const y of this._meshes) {
          const I = y.morphTargetManager;
          if (I) for (const F of [...S.inNames, ...S.outNames]) {
            const w = I.getTargetByName(F);
            w && (w.influence = 0);
          }
          const T = this._restStates.get(y);
          y.scaling[o] = (T ? T.scaling[o] : 1) * B;
        }
        continue;
      }
      const z = P ? u + D * b.MAX_INFLUENCE : Math.max(u - D * b.MAX_INFLUENCE, u * b.MIN_SHRINK_FRACTION), G = P ? Math.min(M, z) : Math.max(M, z), Oe = P ? (G - u) / D : M < u ? (u - G) / D : 0, xe = Math.max(0, Math.min(b.MAX_INFLUENCE, Oe)), ie = M / G;
      Math.abs(ie - 1) > 1e-6 && this._warnOnce(`${n}:${P ? "over" : "under"}`, `[MorphStretch] "${this.sceneObject.name}" ${n} ${a}=${M} exceeds the morph range (${P ? "max" : "min"} ${z.toFixed(3)}); scaling the remainder (detail stretches)`);
      for (const y of this._meshes) {
        const I = this._restStates.get(y);
        I && (y.scaling[o] = I.scaling[o] * ie * C);
        const T = y.morphTargetManager;
        if (T) {
          for (const F of Pe) {
            const w = T.getTargetByName(F);
            w && (w.influence = 0);
          }
          for (const F of se) {
            const w = T.getTargetByName(F);
            w && (w.influence = xe);
          }
        }
      }
    }
    for (const n of this._meshes)
      n.computeWorldMatrix(!0), n.refreshBoundingInfo(!1, !0);
    this._refreshSiblingShape();
  }
  _applyContain(e) {
    const s = this._resolvedSize;
    let i = null;
    for (const { key: r, field: n } of x) {
      const o = s ? s[r] > 0 ? s[r] : void 0 : this._sizeOf(n);
      if (o === void 0) continue;
      const a = e[r];
      if (!(a > 0)) continue;
      const c = o / a;
      i = i === null ? c : Math.min(i, c);
    }
    if (i === null) {
      for (const { axis: r, key: n } of x) this._resetAxis(r, n);
      return;
    }
    for (const r of this._meshes) {
      const n = this._restStates.get(r);
      n && r.scaling.set(n.scaling.x * i, n.scaling.y * i, n.scaling.z * i);
      const o = r.morphTargetManager;
      if (o)
        for (let a = 0; a < o.numTargets; a++) {
          const c = o.getTarget(a);
          c && K(c.name) && (c.influence = 0);
        }
    }
    for (const r of this._meshes)
      r.computeWorldMatrix(!0), r.refreshBoundingInfo(!1, !0);
    this._refreshSiblingShape();
  }
  _refreshSiblingShape() {
    this.sceneObject.getBehavior(rt)?.refreshShape();
  }
  _resetAxis(e, s) {
    const i = this._axisGroups.get(e);
    for (const r of this._meshes) {
      if (r.isDisposed()) continue;
      const n = this._restStates.get(r);
      n && (r.scaling[s] = n.scaling[s]);
      const o = r.morphTargetManager;
      if (!(!o || !i))
        for (const a of [...i.inNames, ...i.outNames]) {
          const c = o.getTargetByName(a);
          c && (c.influence = 0);
        }
    }
  }
  _resolveMeshes() {
    if (this._meshes.length && this._meshes.every((r) => !r.isDisposed())) return !0;
    const e = this.sceneObject.getOwnedMeshes().filter((r) => r instanceof _e);
    if (!e.length)
      return _.warn(`[MorphStretch] "${this.sceneObject.name}" has no meshes to stretch`), !1;
    this._meshes = e, this._restIsBase = Se(this.sceneObject.src) === "deformation";
    const s = this.sceneObject.transform;
    s.computeWorldMatrix(!0);
    const i = s.getWorldMatrix().clone().invert();
    this._restStates.clear();
    for (const r of e) {
      r.computeWorldMatrix(!0);
      const n = r.getWorldMatrix().multiply(i), o = new f();
      n.decompose(o), o.set(Math.abs(o.x), Math.abs(o.y), Math.abs(o.z)), this._restStates.set(r, {
        scaling: r.scaling.clone(),
        rel: n,
        relScale: o,
        isBackground: Le(r.material?.name) !== null
      });
    }
    this._axisGroups.clear();
    for (const r of e) {
      const n = r.morphTargetManager;
      if (n) {
        for (let o = 0; o < n.numTargets; o++) {
          const a = n.getTarget(o);
          if (!a) continue;
          const c = K(a.name);
          if (!c) continue;
          let l = this._axisGroups.get(c.axis);
          l || (l = {
            inNames: [],
            outNames: []
          }, this._axisGroups.set(c.axis, l));
          const h = c.isIn ? l.inNames : l.outNames;
          h.includes(a.name) || h.push(a.name);
        }
        break;
      }
    }
    return this._restCentre = this._measureRestBounds(), this._calibrate(), this._measureSeams(), !0;
  }
  _measureRestBounds() {
    const e = [];
    for (const n of this._meshes) {
      const o = n.morphTargetManager;
      if (!o) continue;
      const a = /* @__PURE__ */ new Map();
      for (let c = 0; c < o.numTargets; c++) {
        const l = o.getTarget(c);
        l && (a.set(l.name, l.influence), l.influence = 0);
      }
      e.push([n, a]);
    }
    const s = new f(1 / 0, 1 / 0, 1 / 0), i = new f(-1 / 0, -1 / 0, -1 / 0), r = new f();
    for (const n of this._meshes) {
      n.refreshBoundingInfo(!1, !0);
      const o = this._restStates.get(n)?.rel;
      if (!o) continue;
      const a = n.getBoundingInfo().boundingBox;
      for (const c of a.vectors)
        f.TransformCoordinatesToRef(c, o, r), s.minimizeInPlace(r), i.maximizeInPlace(r);
    }
    for (const [n, o] of e) {
      const a = n.morphTargetManager;
      if (a)
        for (const [c, l] of o) {
          const h = a.getTargetByName(c);
          h && (h.influence = l);
        }
    }
    return this._baseSize = Number.isFinite(s.x) ? i.subtract(s) : null, this._baseSize && s.add(this._baseSize.scale(0.5));
  }
  _calibrate() {
    this._axisDeltas.clear();
    for (const [e, { axis: s, key: i }] of x.entries()) {
      const r = this._axisGroups.get(s);
      if (!r) continue;
      const n = (o) => {
        let a = 0;
        for (const c of this._meshes) {
          const l = c.morphTargetManager;
          if (!l) continue;
          const h = c.getVerticesData(W.PositionKind);
          if (!h) continue;
          const d = this._restStates.get(c)?.relScale[i] ?? 1;
          for (const u of o) {
            const m = l.getTargetByName(u)?.getPositions();
            if (m)
              for (let g = e; g < m.length; g += 3) {
                const p = Math.abs(m[g] - h[g]) * d;
                p > a && (a = p);
              }
          }
        }
        return a * 2;
      };
      this._axisDeltas.set(s, {
        outDelta: n(r.outNames),
        inDelta: n(r.inNames)
      });
    }
  }
  _measureSeams() {
    this._seamMin.clear();
    const e = this._baseSize;
    if (e)
      for (const [s, { axis: i, key: r }] of x.slice(0, 2).entries()) {
        if (!this._canShrink(i)) continue;
        const n = this._axisGroups.get(i).inNames;
        let o = 1 / 0;
        for (const a of this._meshes) o = Math.min(o, this._halvesMeet(a, s, n));
        o < b.MAX_INFLUENCE && this._seamMin.set(i, e[r] - o * this._axisDeltas.get(i).inDelta);
      }
  }
  _halvesMeet(e, s, i) {
    const r = e.morphTargetManager, n = e.getVerticesData(W.PositionKind), o = this._restStates.get(e)?.rel;
    if (!r || !n || !o) return 1 / 0;
    const a = o.m, c = n.length / 3, l = new Float64Array(c), h = new Float64Array(c);
    for (let d = 0; d < c; d++) l[d] = n[d * 3] * a[s] + n[d * 3 + 1] * a[4 + s] + n[d * 3 + 2] * a[8 + s] + a[12 + s];
    for (const d of i) {
      const u = r.getTargetByName(d)?.getPositions();
      if (u)
        for (let m = 0; m < c; m++) {
          const g = m * 3;
          h[m] += (u[g] - n[g]) * a[s] + (u[g + 1] - n[g + 1]) * a[4 + s] + (u[g + 2] - n[g + 2]) * a[8 + s];
        }
    }
    return ot(l, h, b.MAX_INFLUENCE);
  }
};
export {
  Qe as a,
  Bt as c,
  X as i,
  kt as l,
  rt as n,
  U as o,
  Gt as r,
  zt as s,
  jt as t
};

//# sourceMappingURL=morphstretch-YfBvUhFE.js.map